import { axiosInstance } from '@src/services/common';

const HARDCODE_AGGREGATIONS_DUMMY_ID_MAP: Record<string, string> = {
  unique_user_id: 'Users',
  user_conversion_rate: 'Users',
  count_of_records: 'Conversions',
  conversion_rate: 'Conversions',
  unique_client_id: 'Devices',
  device_conversion_rate: 'Devices',
};

const HARDCODE_AGGREGATIONS_DESCRIPTION_MAP: Record<string, string> = {
  unique_user_id:
    'Count of unique users who followed the complete pattern from Step 1 through the current step without skipping any intermediate steps.',
  user_conversion_rate:
    'Percentage of users from the original Step 1 cohort who reached the current step without skipping any intermediate steps.',
  count_of_records:
    'Total number of times the complete pattern, from Step 1 through the current step, was completed. This counts all instances, including repeat completions by the same user.',
  conversion_rate:
    'Percentage of funnel initiations that successfully completed the entire pattern from Step 1 through the current step. Calculated as (Total Conversions ÷ Total Initiations on Step 1) × 100%.',
  unique_client_id:
    'Count of unique Devices (ClientIDs) that followed the complete pattern from Step 1 through the current step without skipping any intermediate steps.',
  device_conversion_rate:
    'Percentage of unique Devices (ClientIDs) from the original Step 1 cohort who reached the current step without skipping any intermediate steps.',
  mean_time_since_prior_ms:
    'Average time taken for the transition from the previous step to the current step.',
  mean_time_since_beginning_ms:
    'Average time taken to complete the entire pattern from Step 1 through the last step.',
};

function enhanceAggregationUnit(id: string): string {
  if (id.endsWith('_rate')) {
    return '%';
  }

  if (id.endsWith('_ms')) {
    return 'ms';
  }

  return '#';
}

export async function getAggregations() {
  const response = await axiosInstance.get<{
    aggregations: Array<Aggregation & { cm_id: string }>;
  }>('/gm/v1/metadata/aggregations');

  return response.data.aggregations.map(
    ({ cm_id, ...it }) =>
      ({
        ...it,
        id: cm_id,
        unit: enhanceAggregationUnit(cm_id),
        dummyId: HARDCODE_AGGREGATIONS_DUMMY_ID_MAP[cm_id],
        description: HARDCODE_AGGREGATIONS_DESCRIPTION_MAP[cm_id],
      }) as Aggregation,
  );
}
